// extracted by mini-css-extract-plugin
export default {"masonryGrid":"Search_masonryGrid__7HZvh","masonryGridColumn":"Search_masonryGridColumn__UggvK","more":"Search_more__ruM7X"};